"use client";

import { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface PWAContextType {
	is_pwa: boolean;
}

const PWAContext = createContext<PWAContextType | undefined>(undefined);

function checkPWA() {
	if (typeof window === "undefined") return false;
	// iOS PWA detection
	if ('standalone' in window.navigator && !!(window.navigator.standalone)) {
		return true;
	}
	// Android/other PWA detection
	if (window.matchMedia('(display-mode: standalone)').matches) {
		return true;
	}
	return false;
}

export function PWAProvider({ children }: { children: ReactNode }) {
	const [is_pwa, setIsPWA] = useState(false);

	useEffect(() => {
		setIsPWA(checkPWA());
	}, []);

	return (
		<PWAContext.Provider value={{ is_pwa }}>
			{children}
		</PWAContext.Provider>
	);
}

export function usePWA() {
	const context = useContext(PWAContext);
	if (context === undefined) {
		throw new Error('usePWA must be used within a PWAProvider');
	}
	return context;
}

